import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '@app/components/protectedRoute';
import 'leaflet/dist/leaflet.css';
import './App.css';


const Map     = lazy(() => import('./features/map'))
const Login   = lazy(() => import('./features/login'))
const Admin   = lazy(() => import('./features/admin'))

const theme = createTheme({});

function App() {

  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<h1>Loading...</h1>}>
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/admin/*' element={<ProtectedRoute component={Admin}/> } />
          <Route path='*' element={<ProtectedRoute component={Map}/> } />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
